import { render, staticRenderFns } from "./VideoFormatter.vue?vue&type=template&id=61abe62a&scoped=true&"
import script from "./VideoFormatter.vue?vue&type=script&lang=js&"
export * from "./VideoFormatter.vue?vue&type=script&lang=js&"
import style0 from "./VideoFormatter.vue?vue&type=style&index=0&id=61abe62a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61abe62a",
  null
  
)

export default component.exports